import React from 'react'
import {AiOutlineHome,AiOutlineMail} from 'react-icons/ai'
import {BiPhoneCall, BiInfoCircle} from 'react-icons/bi'
import BreadCrum from '../components/BreadCrum'
import Container from '../components/Container'
import Meta from '../components/Meta'

const Contact = () => {
  return (
    <>
      <Meta title='Contact Us'/>
      <BreadCrum title='Contact Us' />
      <Container class1="contact-wrapper py-5 home-wrapper-2">
          <div className="row">
            <div className="col-12">
              map here !
            </div>
            <div className="col-12 mt-5">
              <div className="contact-inner-wrapper d-flex justify-content-between">
                <div>
                  <h3 className="contact-title mb-4">Contact</h3>
                  <form action="" className="d-flex flex-column gap-15">
                    <div>
                      <input type="text" className="form-control" placeholder='Full Name' />
                    </div>
                    <div>
                      <input type="email" className="form-control" placeholder='Email Address' />
                    </div>
                    <div>
                      <input type="tel" className="form-control" placeholder='Mobile Number' />
                    </div>
                    <div>
                      <textarea name="" id="" cols="30" rows="4" className="form-control" placeholder='Your comment'></textarea>
                    </div>
                    <div>
                      <button type='submit' className='button mb-0'>Submit</button>
                    </div>
                  </form>
                </div>
                <div>
                  <h3 className="contact-title mb-4">Get in touch with us</h3>
                  <div>
                    <ul className="ps-0">
                      <li className='mb-3 d-flex align-items-center gap-15'>
                        <AiOutlineHome className='fs-5' />
                        <address className="mb-0">
                          Dasht-e-Barchi, Kabul, Afghanistan
                        </address>
                      </li>
                      <li className='mb-3 d-flex align-items-center gap-15'>
                        <BiPhoneCall className='fs-5' />
                        <a href="tel:+93 799225732">+93 799225732</a>
                      </li>
                      <li className='mb-3 d-flex align-items-center gap-15'>
                        <AiOutlineMail className='fs-5' />
                        <a href="mailto:fayeq.rahmat@gmail.com">fayeq.rahmat@gmail.com</a>
                      </li>
                      <li className='mb-3 d-flex align-items-center gap-15'>
                        <BiInfoCircle className='fs-5' />
                        <p className="mb-0">Monday-Friday 8 AM - 8 PM</p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </Container>
    </>
  )
}

export default Contact